import { breakpoints } from '@bnnvara/breakpoints';
import styled from 'styled-components';

export const FollowButtonContainer = styled.div`
  margin-top: 12px;
  margin-bottom: 4px;
  ${breakpoints.md} {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 0px;
    margin-top: 24px;
  }
`;
